import { Injectable } from "@angular/core";
import moment from "moment";
import Swal from "sweetalert2";
const FileSaver = require("file-saver");
@Injectable({
  providedIn: "root",
})
export class Utils {
  static allowedImageFormats = ["png", "jpg", "jpeg", "PNG", "JPG", "JPEG"];
  static MED_TYPE = ["Inj", "Tab", "Cap", "Syp", "O.susp", "O.Liq", "others"];

  static Toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 3500,
  });
  static showToast(type, title) {
    Utils.Toast.fire({
      type: type,
      title: title
    });
  }

  static SHARE_URL = {
    FACEBOOK: "https://www.facebook.com/sharer/sharer.php?u=",
    TWITTER: "https://twitter.com/intent/tweet?url=",
    MAIL: "mailto:abc@abc.com?body=",
    PINTREST: "https://in.pinterest.com/pin/create/button/?url=",
    WHATSAPP: "https://web.whatsapp.com/send?text=",
    LINKEDIN: "https://www.linkedin.com/sharing/share-offsite/?url=",
  };
  static STATE = [
    { key: "ANDHRA PRADESH", value: "ANDHRA PRADESH" },
    { key: " ASSAM", value: "ASSAM" },
    { key: "ARUNACHAL PRADESH", value: "ARUNACHAL PRADESH" },
    { key: "GUJRAT", value: "GUJRAT" },
    { key: "BIHAR", value: "BIHAR" },
    { key: "HARYANA", value: "HARYANA" },
    { key: "HIMACHAL PRADESH", value: "HIMACHAL PRADESH" },
    { key: "JAMMU & KASHMIR", value: "JAMMU & KASHMIR" },
    { key: "KARNATAKA", value: "KARNATAKA" },
    { key: "KERALA", value: "KERALA" },
    { key: "MADHYA PRADESH", value: "MADHYA PRADESH" },
    { key: "MAHARASHTRA", value: "MAHARASHTRA" },
    { key: "MANIPUR", value: "MANIPUR" },
    { key: "MEGHALAYA", value: "MEGHALAYA" },
    { key: "MIZORAM", value: "MIZORAM" },
    { key: "NAGALAND", value: "NAGALAND" },
    { key: "ORISSA", value: "ORISSA" },
    { key: "RAJASTHAN", value: "RAJASTHAN" },
    { key: "SIKKIM", value: "SIKKIM" },
    { key: "TAMIL NADU", value: "TAMIL NADU" },
    { key: "TRIPURA", value: "TRIPURA" },
    { key: "UTTAR PRADESH", value: "UTTAR PRADESH" },
    { key: "WEST BENGAL", value: "WEST BENGAL" },
    { key: "DELHI", value: "DELHI" },
    { key: "GOA", value: "GOA" },
    { key: "PONDICHERY", value: "PONDICHERY" },
    { key: "LAKSHDWEEP", value: "LAKSHDWEEP" },
    { key: "DAMAN & DIU", value: "DAMAN & DIU" },
    { key: "DADRA & NAGAR", value: "DADRA & NAGAR" },
    { key: "CHANDIGARH", value: "CHANDIGARH" },
    { key: "ANDAMAN & NICOBAR", value: "ANDAMAN & NICOBAR" },
    { key: "UTTARANCHAL", value: "UTTARANCHAL" },
    { key: "HARKHAND", value: "HARKHAND" },
    { key: "CHATTISGARH", value: "CHATTISGARH" },
    { key: "PUNJAB", value: "PUNJAB" },
  ];


  static BLOODGROUP = [
    { key: "A+", value: "A+" },
    { key: "A-", value: "A-" },
    { key: "B+", value: "B+" },
    { key: "B-", value: "B-" },
    { key: "O+", value: "O+" },
    { key: "O-", value: "O-" },
    { key: "AB+", value: "AB+" },
    { key: "AB-", value: "AB-" },
  ];


  static URLTYPE = {
    SIGNURL: "signUrl",
    IMGURL: "imgUrl",
  };

  static IMGFILE = "image";

  static ALLOWED_TYPE = {
    HEALTHCARE_PROVIDER: "healthcare_provider",
    ADMIN: "admin",
    PATIENT: "patient",
  };

  static timesNow: any = {
    hour: parseInt(moment().format("HH")),
    minute: parseInt(moment().format("mm")) + 1,
  };

  static constructTime(time: any, addon: number): any {
    if (time && addon) {
      let { hour, minute } = time;
      let newTime = { hour: hour, minute: minute + addon };
      if (newTime.minute > 59) {
        newTime = { hour: hour + 1, minute: newTime.minute - 60 };
      }
      return newTime;
    }
  }

  static isPastDate(startDate, endDate, time): any {
    let isValid: boolean = false;
    if (startDate && endDate && time) {
      let { day, month, year } = startDate;
      let { day: d, month: m, year: y } = endDate;
      let isPastDate = moment(`${y}-${m}-${d}`).isBefore(
        moment(`${year}-${month}-${day}`)
      );

      let isToday = moment(moment().format("YYYY-MM-DD")).isSame(
        moment(`${y}-${m}-${d}`)
      );
      let isInvalidTime = moment(
        `${time.hour}:${time.minute}`,
        "HH:mm"
      ).isBefore(moment(moment(), "HH:mm"));
      let isInvalidTodayTime = isToday && isInvalidTime ? true : false;

      isValid = isPastDate || isInvalidTodayTime ? true : false;
    }
    return isValid;
  }

  static validateStartTime(startTime, startDate): any {
    let isValid: boolean = false;
    if (startTime && startDate) {
      let { day, month, year } = startDate;
      let isToday = moment(moment().format("YYYY-MM-DD")).isSame(
        moment(`${year}-${month}-${day}`)
      );
      let isValidTime = moment(
        `${startTime.hour}:${startTime.minute}`,
        "HH:mm"
      ).isBefore(moment(moment(), "HH:mm"));
      isValid = isToday && isValidTime ? true : false;
    }
    return isValid;
  }

  static validateEndTime(startTime, endTime): any {
    let isInvalid: boolean = false;
    if (startTime && endTime) {
      let { hour, minute } = startTime;
      let { hour: h, minute: m } = endTime;
      isInvalid = moment(`${h}:${m}`, "HH:mm").isSameOrBefore(
        moment(`${hour}:${minute}`, "HH:mm")
      );
    }
    return isInvalid;
  }

  // This method is used to validate if a key is present in a JSON
  static isNullOrEmpty(json, key) {
    if (json && key in json && json[key] != null) {
      if (typeof json[key] == "string") {
        if (!(json[key] == "")) {
          return false;
        }
      } else {
        return false;
      }
    }
    return true;
  }

  static removeNullAndEmpty(data) {
    if (data) {
      return Object.entries(data).reduce(
        (a, [k, v]) => (v == null || v == "" ? a : { ...a, [k]: v }),
        {}
      );
    }
    return data;
  }

  static removeNullAndUndefined(data) {
    if (data) {
      return Object.entries(data).reduce(
        (a, [k, v]) => (v == null || v == undefined ? a : { ...a, [k]: v }),
        {}
      );
    }
    return data;
  }

  static USER_TYPE: any = {
    admin: 1,
    physician: 2,
    front_desk: 3,
    patient: 4,
    superadmin: 5,
  };

  static STAR_SIZE = "22px";
  static zipRegex = /^\d{6}$/;
  //Make date format sent in API request
  static dateApiRequestformat(date) {
    date = new Date(date);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    return `${y}-${m}-${d}`;
  }
  static today = new Date();
  static minDobDate = new Date(new Date().getFullYear() - 100, 0, 1);
  static minDate = {
    year: 1700,
    month: 1,
    day: 1,
  };
  static maxDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate(),
  };
  static miniDate = {
    year: 1900,
    month: 1,
    day: 1,
  };
  static emailpat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  static emailpat_withNoPlus =
    /^[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}/;
  static numberRegex = /^[0-9]+$/;
  static percentageRegex = /^[1-9]$|^[1-9][0-9]$|^(100)$/;
  static alphaRegex = /^[a-zA-Z]+$/;
  static alphaSpaceRegex = /^[a-zA-Z ]+$/;
  static ifscRegex = /^[A-Z]{4}[0][A-Z0-9]{6}$/;
  static accountNumberRegex = /^\d{9,18}$/;
  static nameRegex = /^[a-zA-Z ]*$/;
  static passwordRegex =
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/;
  static defaultEndTimeAddon = 20;
  static CONTACT_NO = "044-49506077";
  static SUPPORT_EMAIL = "support@reliabledrs.com";

  static STATES = [
    {
      label: "Alaskan/Hawaiian Time Zone",
      childrens: [
        { key: "AK", value: "Alaska" },
        { key: "HI", value: "Hawaii" },
      ],
    },
    {
      label: "Pacific Time Zone",
      childrens: [
        { key: "CA", value: "California" },
        { key: "NV", value: "Nevada" },
        { key: "OR", value: "Oregon" },
        { key: "WA", value: "Washington" },
      ],
    },
    {
      label: "Mountain Time Zone",
      childrens: [
        { key: "AZ", value: "Arizona" },
        { key: "CO", value: "Colorado" },
        { key: "ID", value: "Idaho" },
        { key: "MT", value: "Montana" },
        { key: "NE", value: "Nebraska" },
        { key: "NM", value: "New Mexico" },
        { key: "ND", value: "North Dakota" },
        { key: "UT", value: "Utah" },
        { key: "WY", value: "Wyoming" },
      ],
    },
    {
      label: "Central Time Zone",
      childrens: [
        { key: "AL", value: "Alabama" },
        { key: "AR", value: "Arkansas" },
        { key: "IL", value: "Illinois" },
        { key: "IA", value: "Iowa" },
        { key: "KS", value: "Kansas" },
        { key: "KY", value: "Kentucky" },
        { key: "LA", value: "Louisiana" },
        { key: "MN", value: "Minnesota" },
        { key: "MS", value: "Mississippi" },
        { key: "MO", value: "Arkansas" },
        { key: "OK", value: "Oklahoma" },
        { key: "SD", value: "South Dakota" },
        { key: "TX", value: "Texas" },
        { key: "TN", value: "Tennessee" },
        { key: "WI", value: "Wisconsin" },
      ],
    },
    {
      label: "Eastern Time Zone",
      childrens: [
        { key: "CT", value: "Connecticut" },
        { key: "DE", value: "Delaware" },
        { key: "FL", value: "Florida" },
        { key: "GA", value: "Georgia" },
        { key: "IN", value: "Indiana" },
        { key: "ME", value: "Maine" },
        { key: "MD", value: "Maryland" },
        { key: "MA", value: "Massachusetts" },
        { key: "MI", value: "Michigan" },
        { key: "NH", value: "New Hampshire" },
        { key: "NJ", value: "New Jersey" },
        { key: "NY", value: "New York" },
        { key: "NC", value: "North Carolina" },
        { key: "OH", value: "Ohio" },
        { key: "PA", value: "Pennsylvania" },
        { key: "RI", value: "Rhode Island" },
        { key: "SC", value: "South Carolina" },
        { key: "VT", value: "Vermont" },
        { key: "VA", value: "Virginia" },
        { key: "WV", value: "West Virginia" },
      ],
    },
  ];

  getDoctorYears() {
    let years = [];
    for (let i = 1; i <= 25; i++) {
      years.push({ key: i + 1, value: `${i} Years` });
    }
    years.push({ key: ">25", value: "> 25 Years" });
    return years;
  }

  static YearRegex = /^\d{4}$/;

  checkRoleType(type, input) {
    let hasRole = false;
    if (input && input.length > 0) {
      input.forEach((element) => {
        if (element.id && element.id === type) {
          hasRole = true;
        }
      });
    }
    return hasRole;
  }

  checkRoutesAccess(userRoles, allowedRoles) {
    let isAllowed = false;
    let roles = userRoles.map((x) => x.id);
    roles.forEach((role) => {
      if (allowedRoles.includes(role)) {
        isAllowed = true;
      }
    });
    return isAllowed;
  }

  static NOTIFICATION_TYPES = {
    PHYSICIAN_AVAILABILITY_UPDATED: "physician_availability_updated",
    CONSULT_NOW: "consult_now",
    APPOINTMENT_ADDED: "appointment_added",
    APPOINTMENT_UPDATED: "appointment_updated",
    APPOINTMENT_DELETED: "appointment_deleted",
    APPOINTMENT_REMINDER: "appointment_reminder",
    CONSULT_NOW_ONE_HOUR: "consult_now_one_hour",
    ENABLE_ONLINE_CALL: "enable_online_call",
    SEND_ATTACHMENT: "send_attachment",
    JOIN_CHAT: "join_chat",
    PREVIOUS_CHAT: "previous_Chat",
    TYPING_STATUS: "typing_status",
  };

  static messageAction = {
    SENDMESSAGE: "sendmessage",
    GETMESSAGES: "get_messages",
  };

  static DOCTORPROFILETABS = {
    PERSONALINFORMATION: "personalInformation",
    PROFESSIONALINFORMATION: "professionalInformation",
    BANKACCOUNT: "bankAccount",
  };

  static PAYMENT_CONFIG = {
    AMOUNT_CONVERT: 100,
    CURRENCY: "INR",
    NAME: "RELIABLE DRS",
  };

  static ACCOUNT_TYPE = {
    SAVINGS: "savings",
    CURRENT: "current",
  };

  static COUPON_APPLICABLE_TO = {
    ALL: "ALL",
    INDIVIDUAL: "IND",
  };

  static GENDER = [
    { key: "Male", value: "male" },
    { key: "Female", value: "female" },
    { key: "Other", value: "other" },
  ];

  static ONLINE_CONSULTATION_TYPE = [
    { key: "Audio", value: "audio" },
    { key: "Video", value: "video" },
  ];

  static TITLE = [
    { key: "dr", value: "Dr" },
    { key: "mr", value: "Mr" },
    { key: "miss", value: "Miss" },
    { key: "mrs", value: "Mrs" },
  ];

  static DEFAULTDR = "dr";

  static APPOINTMENT_TYPE = {
    IN_PERSON: "in_person",
    PERSONAL: "personal",
    AUDIO: "audio",
    VIDEO: "video",
  };
  static ROLE = {
    PHYSICIAN: "dr",
    PATIENT: "pat",
  };
  static ENABLE_CALL = {
    AUDIO: "enableAudioCall",
    VIDEO: "enableVideoCall",
  };

  static RELATION = [
    { key: "Self", value: "self" },
    { key: "Father", value: "father" },
    { key: "Mother", value: "mother" },
    { key: "Brother", value: "brother" },
    { key: "Sister", value: "sister" },
    { key: "Husband", value: "husband" },
    { key: "Wife", value: "wife" },
    { key: "Son", value: "son" },
    { key: "Daughter", value: "daughter" },
    { key: "Grand Father", value: "grand_father" },
    { key: "Grand Mother", value: "grand_mother" },
    { key: "Other", value: "other" },
  ];
  static ADD_RELATION = [
    { key: "Father", value: "father" },
    { key: "Mother", value: "mother" },
    { key: "Brother", value: "brother" },
    { key: "Sister", value: "sister" },
    { key: "Husband", value: "husband" },
    { key: "Wife", value: "wife" },
    { key: "Son", value: "son" },
    { key: "Daughter", value: "daughter" },
    { key: "Grand Father", value: "grand_father" },
    { key: "Grand Mother", value: "grand_mother" },
    { key: "Other", value: "other" },
  ];
  static PAST_APPOINTMENT = "past";
  static UPCOMING_APPOINTMENT = "upcoming";
  static ALL_APPOINTMENT = "all";

  static APPOINTMENT_REQUEST_TYPE = {
    NEW: "new",
    RESCHEDULE: "reschedule",
    CANCELLED: "cancelled",
    REJECTED: "rejected",
    APPROVAL_REQUESTED: "approval_requested",
  };

  static OFFLINE_APPOINTMENTS = ["in_person", "personal"];
  static MAX_FILE_SIZE = 2097152;
  static MAX_FILE_VIDEO_SIZE = 5242880; // 5 mb

  static FOLLOWUP_STATUS = { YES: "yes", NO: "no" };

  static APPOINTMENT_STATUS = {
    DRAFT: "draft",
    SCHEDULED: "Scheduled",
    APPROVAL_REQUESTED: "approval_requested",
    CANCELLED: "cancelled",
    REJECTED: "rejected",
    COMPLETED: "completed",
    NOT_COMPLETED: "not_completed",
    PENDING: "pending",
    RESCHEDULE: "reschedule",
    NEW: "new",
  };
  static PAYOUT_STATUS = { ON_HOLD: "ON HOLD", PROCESSED: "PROCESSED", 'N/A': "NOT AVAILABLE", "IN_PROGRESS": "IN PROGRESS", FAILED: 'FAILED' };

  static PAGE_COUNT = [10, 20, 30, 40, 50];
  static DEFAULT_PAGE_COUNT_SHOW = 10;

  static DATE_FORMAT = "dd/MM/yyyy";
  static DB_TIMESTAMP_FORMAT = "YYYY-MM-DD HH:mm:ss";

  static DEFAULT_DAYS = 14;
  static DEFAULT_FEE = 0;

  static CHAT_USER_TYPE: any = {
    PHYSICIAN: "phy",
    PATIENT: "pat",
  };

  static INTAKE_FREQ_TYPE_LIST = [
    {
      id: 1,
      value: "Hourly based",
      freq_options: [
        "Every 4 hours",
        "Every 6 hours",
        "Every 8 hours",
        "Every 10 hours",
        "Every 12 hours",
      ],
    },
    {
      id: 2,
      value: "Session based",
      freq_options: [
        "Morning, Afternoon & Night",
        "Morning & Night",
        "Morning & Afternoon",
        "Afternoon & Night",
        "Morning",
        "Afternoon",
        "Evening",
        "Night",
      ],
    },
    {
      id: 3,
      value: "Whenever Required",
      freq_options: ["As and when required"],
    },
  ];

  static INTAKE = ["Before food", "After food", "N/A"];

  static PRESCRIPTIONTYPE = {
    CURRENTPRESCRIPTION: "CurrentPrescription",
    PREVIOUSPRESCRIPTION: "PreviousPrescription",
  };

  static FEEDBACK_TYPE = {
    PHYSICIAN: "physician",
    SOOPERDR: "sooperdr",
  };

  static FEEDBACK_COLORS = {
    CHECKED: "#ffd700",
    UNCHECKED: "#808080",
  };

  static TRANSACTION_STATUS = { ON_HOLD: "ON HOLD", PROCESSED: "PROCESSED" };

  static formatTime(value) {
    let res;
    if (value && typeof value === "string") {
      let keys = value.split(":");
      res =
        Utils.getTime(keys[0]) +
        " : " +
        keys[1] +
        " " +
        Utils.getFormat(keys[0]);
    }
    return res;
  }

  static getTime(time) {
    if (parseInt(time) > 12) {
      time = (parseInt(time) - 12).toString();
      if (time.length == 1) {
        time = "0" + time;
      }
    }
    return time;
  }

  static getFormat(value) {
    if (parseInt(value) < 12) {
      return "AM";
    } else {
      return "PM";
    }
  }

  static termsUrl = "http://reliabledrs.com/terms-and-conditions/";
  static homePageUrl = "https://www.reliabledrs.com/";
  static whoWeUrl = "https://www.reliabledrs.com/about-us/";
  static ourTeamUrl = "https://www.reliabledrs.com/our-team-2/";
  static faqUrl = "https://www.reliabledrs.com/faqs/";
  static contactUsUrl = "https://www.reliabledrs.com/contact-us/";
  static blogUrl = "https://www.reliabledrs.com/blogs/";
  // footer URL
  static aboutUsUrl = "http://reliabledrs.com/about-us/";
  static privacyPolicyUrl = "http://reliabledrs.com/privacy/";

  static downloadFile(doc) {
    fetch(doc.previewUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement("a");
        link.download = doc.name;
        link.href = URL.createObjectURL(blob);
        link.click();
      });
  }

  static CHAT_ACTION = {
    JOINED: "joined",
    LEFT: "left",
    NEW_MESSAGE: "new_message",
    SEND_ATTACHMENT: "send_attachment",
    PREVIOUS_CHAT: "previous_Chat",
  };

  static downloadFileWithSignedUrl(doc) {
    fetch(doc.signedUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement("a");
        link.download = doc.name;
        link.href = URL.createObjectURL(blob);
        link.click();
      });
  }
}
